import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 resignin_otp: { status: "idle" },
};

export const resignin_otp_Slice = createSlice({
 name: "resignin_otp",
 initialState,
 reducers: {
  success_resignin_otp: (state, action) => {
   state.resignin_otp = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_resignin_otp: (state, action) => {
   state.resignin_otp = { status: app_consts.FAIL, message: action.payload };
  },
  reset_resignin_otp: (state) => {
   state.resignin_otp = { status: app_consts.IDLE };
  },
  loading_resignin_otp: (state) => {
   state.resignin_otp = { status: app_consts.LOADING };
  },
 }
});

export const { success_resignin_otp, fail_resignin_otp, reset_resignin_otp, loading_resignin_otp } = resignin_otp_Slice.actions;

export default resignin_otp_Slice.reducer;